import { adoptLoginHandoff } from '../session-http';
import { parseLoginBootstrapHash } from '../utils/login-return-path';

/**
 * Finish the browser's login handoff before the root component starts protected
 * reads. Otherwise a background 401 can renew an empty cookie jar and redirect
 * away while the auth guard is still exchanging the valid refresh token.
 * The guard retains its fallback for handoffs received after application boot.
 */
export async function bootstrapCookieHandoff(
  exchange: (
    refreshToken: string,
    tenant: string,
  ) => Promise<boolean> = adoptLoginHandoff,
): Promise<boolean | null> {
  const originalHash = window.location.hash;
  const handoff = parseLoginBootstrapHash(originalHash);
  if (!handoff) return null;
  try {
    return await exchange(handoff.refreshToken, handoff.tenant);
  } catch {
    return false;
  } finally {
    // Remove credentials even when the exchange fails. Never erase navigation
    // that happened while the request was pending.
    if (window.location.hash === originalHash) {
      try {
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname + window.location.search + handoff.routeHash,
        );
      } catch {
        /* The guard still checks the real session. */
      }
    }
  }
}
